
import { Component, Prop, Vue } from 'vue-property-decorator';
import AuthService from '@/services/auth.service';
import { EventBus } from '@/event-bus';

const auth = new AuthService();

@Component
export default class Navigation extends Vue {
  public currentUser: string = '';
  public accessTokenExpired: boolean | undefined = false;
  public isLoggedIn: boolean = false;

  get username(): string {
      return this.currentUser;
  }

  get currentEnvironment(): string {
    // Check for explicit environment variable first
    const envVar = (process.env as any).NODE_ENV;
    if (envVar) {
      return envVar.toLowerCase();
    }
    
    // Fall back to NODE_ENV
    const nodeEnv = process.env.NODE_ENV;
    if (nodeEnv === 'development') {
      return 'development';
    }
    
    // Default to production if not specified
    return 'production';
  }

  get navbarVariant(): string {
    // For non-production environments, we'll use custom styles instead of Bootstrap variants
    // Production keeps the default 'warning' variant
    if (this.currentEnvironment === 'production') {
      return 'warning';
    }
    return '';
  }

  get navbarStyle(): { [key: string]: string } {
    const environment = this.currentEnvironment;

    // Color mapping for different environments
    const environmentColors: { [key: string]: string } = {
      development: '#90EE90', // Light green
      testing: '#008eff',      // Gold
      staging: '#9370DB',      // Medium purple
      uat: '#ec98cd',          // Light sea green
      production: ''           // Default Bootstrap warning color
    };

    const backgroundColor = environmentColors[environment] || '';
    
    if (backgroundColor) {
      return {
        backgroundColor: backgroundColor
      };
    }
    
    return {};
  }

  get navbarEnvironmentText(): string {
    const environment = this.currentEnvironment;
    const environmentText: { [key: string]: string } = {
      development: 'ENV: Development',
      testing: 'ENV: Testing',
      staging: 'ENV: Staging',
      uat: 'ENV: UAT',
      production: ''
    };
    return environmentText[environment] || '';
    
  }

  private logoff() {
    auth.logout();
  }

  private mounted() {
    auth.getUser().then((user) => {
      if (user !== null) {
        this.currentUser = user.profile.name!;
        this.accessTokenExpired = user.expired;
      }
      this.isLoggedIn = (user !== null && !user.expired);
    });
  }

  private created() {
    EventBus.$on('logged-in', (payLoad: any) => {
      // this doesn't currently do anything in this demo but does get fired on successful login.
      // leaving it here to show how to allow communication between unrelated components - ie. Store -> Component
      console.log('logged-in message received...');
    });
  }

  private destroyed() {
    EventBus.$off('logged-in');
  }
}

